import { useState, useCallback, lazy, Suspense, memo } from 'react';
import styles from './headerCartButtons.module.scss';
import { TouchableButton, TouchableDiv } from '../../common/Touchable';
import cn from 'classnames';
import { ReactComponent as SearchIcon } from '@assets/images/SearchDetails.svg';
import { LABEL } from '@veriables';

const Search = lazy(() => import('@components/common/search'));

const HeaderCartButtons = ({
  serverAppTheme = {},
  orderingPortraitOrientation = false,
  isSearch = false,
  openSearch = () => {},
  closeSearch = () => {},
  searchUpdated = () => {},
  handleLogout = () => {},
}) => {
  const [openKeyboard, setOpenKeyboard] = useState(false);

  const handleSearchClose = useCallback(() => {
    setOpenKeyboard(false);
    closeSearch();
  }, [closeSearch]);

  const handleSearchIconClick = useCallback(() => {
    openSearch();
    setOpenKeyboard(true);
  }, [openSearch]);

  return (
    <div className="d-flex align-items-center h-100">
      <div className={cn(isSearch ? 'col-12 px-0' : 'col-4')}>
        {!isSearch ? (
          <TouchableDiv
            className={cn("d-flex justify-content-center align-items-center rounded h-85",styles.searchIconBox)}
            style={{ background: serverAppTheme?.iconcolor_bg_box }}
            onClick={handleSearchIconClick}
          >
            <SearchIcon
              stroke={serverAppTheme?.iconcolor}
              aria-hidden="true"
              style={{ width: '50%' }}
            />
          </TouchableDiv>
        ) : (
          <Suspense fallback={null}>
            <Search
              placeholderName={LABEL().SEARCH || 'Search'}
              isSearch={isSearch}
              onChange={searchUpdated}
              setOpenKeyboard={setOpenKeyboard}
              openKeyboard={openKeyboard}
              onClose={handleSearchClose}
              customStyle={{ right: '0%', top: '50%', fontSize: '16px', transform: 'translateY(-50%)' }}
              isTop
              serverAppTheme={serverAppTheme}
            />
          </Suspense>
        )}
      </div>
      {!isSearch && (
        <div className="col-8">
          <TouchableButton
            className={cn(
              styles.Logoutbtn,
              'px-3 h-85 rounded',
              orderingPortraitOrientation ? 'mr-0' : 'mr-5'
            )}
            role="presentation"
            onClick={e => {
              e.preventDefault();
              handleLogout();
            }}
          >
            {LABEL().CLS_LOGOUT}
          </TouchableButton>
        </div>
      )}
    </div>
  );
};

export default memo(HeaderCartButtons);
